import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"
import { useFetch } from '../../../../../../hooks'
import { Card } from '../../../../../../components/Card'
import Table from '../../../../../../components/Table'
import Icon from '../../../../../../components/Icon'
import Button from '../../../../../../components/inputs/Button'
import Buttons from '../../../../../../modules/Buttons'
import InfoBar from '../../../../../../modules/InfoBar'
import { Store } from '../../../../../../context/store'
import { uniqBy, compose, prop, ifElse, map, has, identity } from 'ramda'

const Calvings = ({ grpid, infoBar, calvings }) => {
    const history = useHistory();
    const { actions } = Store();

    const { doFetch } = useFetch({
        url: '/rpc/get_calvings',
        method: 'POST',
        state: false
    })

    const [data, setData] = useState([]);
    const [nextID, setNextID] = useState();

    useEffect(() => {
        const filter = compose(
            map(
                ifElse(
                    has('cow_no'),
                    item => ({ ...item, row_no: prop('cow_no', item) }),
                    identity
                )
            ),
            uniqBy(
                prop('row_id')
            ));
        actions.setCowsList(filter(data));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (calvings && calvings.table) {
            setData(calvings.table.data || [])
            setNextID(calvings.table.nextid)
        }
    }, [calvings])

    const handleClickNextID = async () => {
        try {
            const res = await doFetch({
                data: {
                    row_id: grpid,
                    nextid: nextID
                }
            })
            if (res.data) {
                setData(prevData => [...prevData, ...res.data])
            }
            setNextID(res.nextid)
        } catch (err) {
            console.log(err)
        }
    }

    const handleClickRow = cow => () => {
        history.push({
            pathname: `/manage/herd/cow/${cow.cow_no || cow.row_no}`,
            state: {
                rowid: cow.row_id
            }
        });
    }


    return (
        <>
            {
                infoBar &&
                <InfoBar
                    lastUpdate={infoBar.lastUpdate}
                    translation={infoBar.translation}
                    noContainer
                />
            }
            <Card>
                {
                    calvings &&
                    <Table
                        columns={[{
                            name: calvings.field1,
                            key: 'cow_no'
                        }, {
                            name: calvings.field2,
                            key: 'birthdate'
                        }, {
                            name: calvings.field3,
                            key: 'days'
                        }, {
                            cell: () => <Icon name='arrow' />,
                            style: {
                                maxWidth: '14px',
                                alignSelf: 'center',
                                marginRight: 0
                            }
                        }]}
                        data={data}
                        divider
                        minWidth={'280px'}
                        hover
                        onClickRow={handleClickRow}
                    />
                }
                {
                    nextID &&
                    <Buttons style={{ marginBottom: '-20px' }}>
                        <Button transparent green fullWidth noMargin style={{ padding: '20px 0' }} onClick={handleClickNextID}>{calvings.footer}</Button>
                    </Buttons>
                }
            </Card>
        </>
    )
}

export default Calvings
